/**
 * @description : 电影院客户端接口
 */
import request from '@/api/request'

/**
 * 获取城市列表
 */
export function getCity(data) {
    return request({
        url: '/manager/Movie/getCity',
        method: 'post',
        data
    })
}

/**
 * 获取城市分区列表
 */
export function getArea(data) {
    return request({
        url: '/manager/Movie/getArea',
        method: 'post',
        data
    })
}

/**
 * 获取影院列表
 */
export function getCinema(data) {
    return request({
        url: '/manager/Movie/getCinema',
        method: 'post',
        data
    })
}

/**
 * 获取排片影院列表
 */
export function getFilmSched(data) {
    return request({
        url: '/manager/Movie/getFilmSched',
        method: 'post',
        data
    })
}

/**
 * 获取影片列表
 */
export function getFilm(data) {
    return request({
        url: '/manager/Movie/getFilm',
        method: 'post',
        data
    })
}

/**
 * 获取场次
 */
export function getCinemaSched(data) {
    return request({
        url: '/manager/Movie/getCinemaSched',
        method: 'post',
        data
    })
}
/**
 * 获取场次座位
 */
export function getSchedSeat(data) {
    return request({
        url: '/manager/Movie/getSchedSeat',
        method: 'post',
        data
    })
}
/**
 * 锁座订单
 */
export function submitOrder(data) {
    return request({
        url: '/manager/Movie/submitOrder',
        method: 'post',
        data
    })
}
/**
 * 确认订单（付款）
 */
export function confirmOrder(data) {
    return request({
        url: '/manager/Movie/confirmOrder',
        method: 'post',
        data
    })
}
/**
 * 获取订单信息
 */
export function getOrderInfo(data) {
    return request({
        url: '/manager/Movie/getOrderInfo',
        method: 'post',
        data
    })
}
/**
 * 电影票
 */
export function getVirtualMoney(data) {
  return request({
      url: '/manager/Movie/getVirtualMoney',
      method: 'post',
      data
  })
}
/**
 * 电影票
 */
export function onLineOrder(data) {
  return request({
      url: '/manager/Movie/onLineOrder',
      method: 'post',
      data
  })
}